export default "__VITE_ASSET__BG9w4awI__"